// extracted by mini-css-extract-plugin
module.exports = {"slider_wrapper":"Slider_slider_wrapper__L2NDW","slider_value":"Slider_slider_value__wmAET","on":"Slider_on__7JPzS","disabled":"Slider_disabled__PbdxA"};